<cfi-top></cfi-top>
<cfi-navbar></cfi-navbar>

<div>
    <router-outlet></router-outlet>
</div>

<cfi-footer></cfi-footer>
